import { EnumSchema } from '../metadata-schema';

export const Uitstroom: EnumSchema = {
	"type": "string",
	"title": "Uitstroom",
	"enum": [
		"Intern",
		"Intern (tussentijds)",
		"Extern",
		"Extern (tussentijds)",
		"VAVO",
		"VAVO (tussentijds)"
	]
};
